function drawLineBetween(element1, element2) {
    var off1 = getOffset(element1);
    var off2 = getOffset(element2);
    
    // bottom right
    var x1 = off1.left + off1.width;
    var y1 = off1.top + (off1.height/2);

    // top right
    var x2 = off2.left;
    var y2 = off2.top + (off1.height/2);

    // distance
    var length = Math.sqrt(((x2-x1) * (x2-x1)) + ((y2-y1) * (y2-y1)));
    
    // center
    var cx = ((x1 + x2) / 2) - (length / 2);
    var cy = ((y1 + y2) / 2) - 1;

    // angle
    var angle = Math.atan2((y1-y2),(x1-x2))*(180/Math.PI);

    // make hr
    var htmlLine = "<div class='tree-line' style='left:" + cx + "px; top:" + cy + "px; width:" + length + "px; -moz-transform:rotate(" + angle + "deg); -webkit-transform:rotate(" + angle + "deg); -o-transform:rotate(" + angle + "deg); -ms-transform:rotate(" + angle + "deg); transform:rotate(" + angle + "deg);' />";

    if ($('body').css('visibility') == 'hidden') {
      $('.structure').append(htmlLine);
    }
    else {
      $('body').append(htmlLine);
    }
}

function getOffset(el) {
  var x = el.offset().left;
  var y = el.offset().top;
  var w = el.width();
  var h = el.height();
  return { top: y, left: x, width: w, height: h };
}

$(document).on("turbo:load", fullScreen);
$(window).on('resize', function() {
  $('.tree-line').remove();
  initTreeLines();
});

// TODO refactor this 
function initTreeLines() {
  $(".pull-right i.glyphicon-eye-open").on('click', function(e) {
    e.preventDefault();
    location.href = this.closest('span').dataset.url
  });
  $("[data-node-leaf-id]").each(function(){
    var firstElement = $(this);
    var childIds = $(this).data("leaf-child-node-ids");
    childIds.forEach(function(id){
      var secondElement = $("[data-node-leaf-id='" + id + "']");
      drawLineBetween(firstElement, secondElement);
    });
    var childIds = $(this).data("leaf-child-content-ids");
    childIds.forEach(function(id){
      var secondElement = $("[data-content-leaf-id='" + id + "']");
      drawLineBetween(firstElement, secondElement);
    });
    firstElement.on('mouseenter', function(){
      var enterChildNodeIds = $(this).data("leaf-child-node-ids");
      var enterChildContentIds = $(this).data("leaf-child-content-ids");
      enterChildNodeIds.forEach(function(id){
        var secondElement = $("[data-node-leaf-id='" + id + "']");
        secondElement.addClass("highlight");
      });
      enterChildContentIds.forEach(function(id){
        var secondElement = $("[data-content-leaf-id='" + id + "']");
        secondElement.addClass("highlight");
      });
    });
    firstElement.on('mouseleave', function(){
      var exitChildNodeIds = $(this).data("leaf-child-node-ids");
      var exitChildContentIds = $(this).data("leaf-child-content-ids");
      exitChildNodeIds.forEach(function(id){
        var secondElement = $("[data-node-leaf-id='" + id + "']");
        secondElement.removeClass("highlight");
      });
      exitChildContentIds.forEach(function(id){
        var secondElement = $("[data-content-leaf-id='" + id + "']");
        secondElement.removeClass("highlight");
      });
    });
  });
}

function fullScreen() {
  initTreeLines();
  var structure = $('.structure'),
      fullScreenBtn = $('.resize-btn');

  if (structure.length > 0) {
    var structureParent = structure.parent(),
        childPanels = structure.find('.panel');

    fullScreenBtn.on('click', function () {
      if (structure.css('position') == 'static') {
        $('body').css({'visibility': 'hidden', 'overflow': 'hidden'});
        structure.addClass('full-screen-structure');
        structureParent.css({'position': 'inherit'});
        childPanels.css({'position': 'static'});
        $('.full-screen-btn').hide();
        $('.small-screen-btn').show();
      }
      else {
        $('body').css({'visibility': 'visible', 'overflow': 'scroll'});
        structure.removeClass('full-screen-structure');
        structureParent.css({'position': 'relative'});
        childPanels.css({'position': 'relative'});
        $('.small-screen-btn').hide();
        $('.full-screen-btn').show();
      }
      $('.tree-line').remove();
      initTreeLines();
    });
  }
}
